import {NDVSClient} from "../../client/NDVSClient";
import {getStationCode} from "../../util/NetworkUtil";

export function fetchDrivers({filters}, dispatcher) {
    NDVSClient.getDriversList({
        stationCode : getStationCode(),
        active : true
    }).then((response) => {
        if (response.valid) {
            console.log(response);
            var driversList = response
                .data.driverList
                .map(({
                          driverName, employeeId, store, storeId
                      }) => ({

                    DRIVER_NAME: driverName || "",
                    DRIVER_ID: employeeId.toString() || "",
                    IS_STORE: store || false,
                    STORE_ID: storeId
                }));
            dispatcher({
                type: "SET_DATA",
                data: driversList
            })
        } else {
            dispatcher({
                type: "SET_ERROR"
            })
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/network/DriverListAPI.js